/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^\w+[\w+\-.]*@[a-z\d][a-z\d\-.]*[a-z\d]\.[a-z]{2,}$/i;

// From https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
export const validateEmail = (value?: string) => (value ? EMAIL_REGEX.test(value.toLowerCase()) : false);
